import { Suspense, Fragment } from "react";
import { Routes, BrowserRouter as Router, Route } from "react-router-dom";
import { routes } from "./routes";

const renderRoute = ({ component: Component, ...route }) => {
  //TODO an Auth check component will be made when the app matures to authentication stage
  const Guard = route.isAuthenticated ? Fragment : Fragment;
  const Layout = route.layout ? route.layout : Fragment;

  return (
    <Route
      key={route.path}
      path={route.path}
      element={
        <Layout>
          <Suspense fallback={<></>}>
            <Guard>
              <Component />
            </Guard>
          </Suspense>
        </Layout>
      }
    />
  );
};

export const AppRoutes = () => {
  return (
    <Router>
      <Routes>{routes.map((route) => renderRoute(route))}</Routes>
    </Router>
  );
};

